module.exports = __webpack_public_path__ + "static/anthony_mobile-b3194b2f8abd926694970e2f9c399618.jpg";